<style lang="less" scoped>
  .content {
    width: 100%;
    flex-direction: column;
  }
  .image-slider-row {
    width: 100%;
  }
  .arrow-row {
    width: 100%;
    text-align: center;
    padding: 8px 0;
  }
  .image-slider {
    width: 100%;
    display: flex;
  }
  .image {
    width: 20%;
    height: 64px;
  }
  .image-slot {
    width: 64px;
    height: 64px;
    opacity: .3;
    background-color: white;
    border-radius: 12px;
    overflow: hidden;
    &.active {
      opacity: 1;
      box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.24);
    }
  }
  .image-panel-component {
    width: 100%;
    height: 100%;
    margin: auto;
  }
  .big-panel-slot {
    width: 270px;
    height: 270px;
  }
  .big-panel {
    width: 100%;
    height: 100%;
    border-radius: 27px;
    background: white;
  }
</style>

<template lang="pug">
  .std-layout
    .header
      header-component(
        @click-stop='redirectBack'
        @click-recall='done')
    .content
      .image-slider-row.arrow-row
        .up-arrow-row
          up-arrow-component(
            @click.native='prevPage'
            v-if='page > 0')
        .image-slider
          .image(v-for='(data, key) in display')
            .image-slot(:class='{ active: key === focus }')
              image-panel-component.image-panel-component(:image='data')
        .down-arrow-row.arrow-row
          down-arrow-component(
            @click.native='nextPage'
            v-if='page < groupCount - 1')
      .big-frame-container
        .big-panel-slot
          image-panel-component.big-panel(:image='focused')
    .footer
      footer-component(
        :time='time'
        @click-next='next'
        @click-prev='prev')
</template>

<script>
import HeaderComponent from '@/components/header/header_recall';
import UpArrowComponent from '@/components/up_arrow';
import ImagePanelComponent from '@/components/image_panel';
import DownArrowComponent from '@/components/down_arrow';
import FooterComponent from '@/components/footer/timer_arrow';

export default {
  data() {
    return {
      page: 0,
      focus: 0,
      time: 0,
    };
  },
  methods: {
    progressTimer() {
      this.time += 1;
    },
    redirectBack() {
      this.$router.go(-1);
    },
    done() {
      this.$router.replace({ name: 'TrainingImageRecall' });
    },
    prev() {
      if (this.focus > 0) {
        this.focus -= 1;
      } else if (this.focus <= 0) {
        if (this.page > 0) {
          this.focus = this.countPerGroup - 1;
          this.prevPage();
        }
      }
    },
    next() {
      if (this.focus + 1 < this.display.length) {
        this.focus += 1;
      } else if (this.focus + 1 >= this.display.length) {
        if (this.page < this.groupCount) {
          this.focus = 0;
          this.nextPage();
        }
      }
    },
    prevPage() {
      if (this.page > 0) {
        this.page -= 1;
        this.focus = this.display.length - 1;
      }
    },
    nextPage() {
      if (this.page + 1 < this.groupCount) {
        this.page += 1;
        this.focus = 0;
      }
    },
  },
  created() {
    window.intervalID = setInterval(this.progressTimer, 1000);
  },
  beforeDestroy() {
    clearInterval(window.intervalID);
  },
  computed: {
    countPerGroup() {
      return this.$store.state.app.units;
    },
    groupCount() {
      return Math.ceil(this.answer.length / this.countPerGroup);
    },
    answer() {
      return this.$store.state.app.answer;
    },
    display() {
      const result = [];
      const start = this.page * this.countPerGroup;
      const end = start + this.countPerGroup;
      for (let i = start; i < end; i += 1) {
        if (this.answer[i]) {
          result.push(this.answer[i]);
        } else {
          break;
        }
      }
      return result;
    },
    focused() {
      return this.display[this.focus];
    },
  },
  components: {
    HeaderComponent,
    UpArrowComponent,
    ImagePanelComponent,
    DownArrowComponent,
    FooterComponent,
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/training/image/start.vue